 
import { RecommendedNutrientQuantityDataWithIds } from './models/fertilization-result.model';
import {
  Template,
  ExecutedTreatment,
  FertilizationSettingWithIds,
  SoilAnalysis,
  OrganicMatterReport,
  FertilizationSettingWithName,
  NitrogenCalculationSettingToggles,
  CustomerFertilizerStock,
} from '../shared/models';

export interface AdviceState {
  selectedCropFieldIds?: number[];
  executedTreatments?: ExecutedTreatment[];
  template?: Template;
  fertilizationSetting?: FertilizationSettingWithIds;
  nitrogenCalculationSettingToggles?: NitrogenCalculationSettingToggles;
  nitrogenCalculationSettingTogglesByAdvices?: NitrogenCalculationSettingToggles[];
  fertilizationSettings?: FertilizationSettingWithName[];
  recommendedNutrientQuantityWithIds?: RecommendedNutrientQuantityDataWithIds[];
  latestSoilAnalysis?: SoilAnalysis;
  organicMatterReport?: OrganicMatterReport;
  customerFertilizerStock?: CustomerFertilizerStock;
  isPrefilling?: boolean;
}

export enum SyncStatusEnum {
  New = 'New',
  Updated = 'Updated',
  NotPresent = 'NotPresent',
}
